module.exports = __webpack_public_path__ + "img/ThreeAxleTractorSingleAxleSemitrailer.613029c0.svg";